import React from 'react';
import { Badge, Button, message, Popconfirm, Row, Table } from 'antd';


class BannersTable extends React.Component{
    render() {

        const { banners } = this.state;
        // console.log(this.state.banners)
        if(!banners) return (
            <div>
                No saved banners
            </div>
        )

        const columns = [
            { title: 'Status | Name', width: 250, dataIndex: 'name', render: (text, record) => {
                return (
                    <Row>
                        <Badge status={
                            (record.active)? 'success' : 'error'
                        }/> 
                    
                        | {record.name}
                    </Row>
                )
            }},
            { title: 'Details', key: '', render: (text, record) => {
                return (
                    <Row>
                        <Row className="banner-title">
                            {record.title}
                        </Row>

                        <Row>
                            Link: {record.link}
                        </Row>

                        <Row>
                            {record.image ? 
                                
                                    <img alt="banner-table" className="banner-table-image" src={record.image.url} />
                            : 
                            null
                            }
                        </Row>
                    </Row>
                )
            } },
            { title: 'Action',  width: 180, key: '',dataIndex: '', render: (record) => {
                return(
                    <Button.Group size='small'>
                    {/* {console.log("edit " , record, ", banners = ", banners)} */}
                        <Button 
                            // disabled={!record.status.planning}
                            style={{fontSize: '12px'}}
                            onClick={() => this.handleEdit(record)} type="primary">
                            Edit
                        </Button>

                        <Popconfirm title="Are you sure to remove experiment?" 
                            onConfirm={() => this.deleteOneBanner(record)} 
                            okText="Yes" 
                            cancelText="No">

                            <Button 
                                // disabled={!record.status.planning} 
                                style={{fontSize: '12px'}}
                                type="danger">
                                Remove
                            </Button>
                            
                        </Popconfirm>
                    </Button.Group>
                )
            } },
            // { title: 'Toggle Status', dataIndex: 'active', key:'active', render: (text,record) => {
            //     return(
            //         <Switch 
            //             defaultChecked={record.active? true : false}
            //             onChange={this.toggleActive}
            //             />
            //     )
            // }}
        ]

        return(
            <Row >
                <Row className="banner-table-title">
                    Banners:
                </Row>

                <Table 
                rowKey='_id'
                dataSource={ this.state.banners }
                columns={columns}
                />
            
            </Row>
        )
    }

    toggleActive = () => {
        //handle state change of active
    }

    constructor(props) {
        super(props);
        this.state = {
            banners: false
        }
        


        //get props from parent, update state
    }

    componentWillMount() {
        this.setState({
            banners: this.props.banners
        })
    }

    componentWillReceiveProps(newProps) {
        // console.log("new props" , newProps)
        this.setState({
            banners: newProps.banners
        })
    }

    handleEdit = (record) => {
        // console.log("edit" , record)
        this.props.editBanner(record);
    }

    deleteOneBanner = (record) => {
        let bannerId = record._id;
        this.props.deleteOneBanner(bannerId);
        message.success("Banner removed")
    }
}

export default BannersTable;


// WEBPACK FOOTER //
// ./src/components/banners/table.js